$(document).ready(function () {

    // Hide new-in when have sale
    $('.product-label-container').each(function () {
        const $container = $(this);
        const hasSale = $container.find('.product-label--sale').length > 0;
        const $newIn = $container.find('.product-label--new-in');

        if (hasSale && $newIn.length) {
            $newIn.hide();
        }
    });

});